import { ExportConfigForm } from "../jobs/ExportConfigForm";

/**
 * Landing page. Once auth + identity + project gates are satisfied
 * (see RootLayout), this is the export configuration form. The
 * persistent JobsBadge in the header lets the user navigate to
 * `/jobs` for past job history at any time.
 */
export function Home() {
    return <ExportConfigForm />;
}
